<template>

    <div id="component-user-list" class="vx-card p-6">
        <!-- Title and Buttons Action -->
        <div class="text-title">
            <span>管理者一覧</span>
        </div>
        <vs-row class="pl-2">
            <vs-col vs-w="6"></vs-col>
            <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="6">
                <vs-button color="success" icon="person_add" @click="setUpCreate">登録</vs-button>
            </vs-col>
        </vs-row>

        <vs-popup id="dialogDelete" title="管理者の削除" :active.sync="activeDelete" button-close-hidden>
            <div>
          <span>
            選択した管理者を削除しますか？
          </span>
            </div>
            <div class="flex justify-end mt-4">
                <vs-button @click="confirmDelete" icon="delete" color="danger" class="mx-2">削除</vs-button>
                <vs-button @click="activeDelete = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
            </div>
        </vs-popup>

        <!-- Create and Edit Dialog -->
        <vs-popup id="dialogAdminUpdate" :title="title" :active.sync="activeInnerPopup" button-close-hidden >
            <div>
                <div>
                    <vx-card title="管理者詳細"
                             card-background ="rgb(240, 238, 241)"
                             height="420px"
                             class="pb-2"
                             style="font-size: 12px">
                        <div>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span class="pt-2">ログインID<span style="color: red" v-if="!submited">*</span></span>
                                </vs-col>
                                <vs-col vs-w="9">
                                    <vs-row>
                                        <vs-input :disabled="!isAdd"  v-validate.immediate="'required|login_id'" maxlength="15" name="ログインID" v-model="login_id" class="w-full mb-2"/>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col vs-offset="3">
                                    <span v-show="submited && isAdd" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("ログインID") | convertError }}</span>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>メールアドレス<span style="color: red">*</span></span>
                                </vs-col>
                                <vs-col vs-w="9">
                                    <vs-row>
                                        <vs-input v-validate.immediate="'required|email|override-email'" maxlength="256" name="メールアドレス" v-model="email" class="w-full mb-2"/>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col vs-offset="3">
                                    <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("メールアドレス") | convertError }}</span>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>電話番号</span>
                                </vs-col>
                                <vs-col vs-w="9">
                                    <vs-row>
                                        <vs-input v-validate.immediate="'numeric'" name="電話番号" v-model="phone_number" maxlength="15" class="w-full mb-2"/>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col vs-offset="3">
                                    <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("電話番号") | convertError }}</span>
                                </vs-col>
                            </vs-row>
                            <vs-row>
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>氏名<span style="color: red">*</span></span>
                                </vs-col>
                                <vs-col vs-w="9">
                                    <vs-row>
                                        <vs-col vs-offset="0" vs-w="4">
                                            <vs-input v-validate.immediate="'required'" placeholder="姓" name="姓" maxlength="64" v-model="family_name" class="w-full mb-2"/>
                                        </vs-col>
                                        <vs-col vs-offset="2" vs-w="4">
                                            <vs-input v-validate.immediate="'required'" placeholder="名" name="名" maxlength="64" v-model="given_name" class="w-full mb-2"/>
                                        </vs-col>
                                    </vs-row>
                                </vs-col>
                            </vs-row>
                            <vs-row class="mb-2">
                                <vs-col vs-offset="3">
                                    <span v-show="submited" class="text-danger font-size-info">{{ errors.first("姓") ?  errors.first("姓"):errors.first("名") | convertError }}</span>
                                </vs-col>
                            </vs-row>
                            <vs-row style="font-size: 12px">
                                <vs-col class="flex items-center" vs-w="3">
                                    <span>状態:</span>
                                </vs-col>
                                <vs-row vs-w="9">
                                    <div v-for="(item,index) in stateFlgOptions" :key=index>
                                        <div v-if="state_flg == VALID_WITHOUT_PWD || isAdd" class="mr-4">
                                            <!-- <vs-radio disabled color="grey" v-model="state_name" :vs-value="item" class="mx-1 pr-1">{{item}}</vs-radio> -->
                                            <input disabled type="radio" v-model="state_name" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                                            <span>{{item}}</span>
                                        </div>
                                        <div v-else class="mr-4">
                                            <!-- <vs-radio v-model="state_name" :vs-value="item" class="mx-1 pr-1">{{item}}</vs-radio> -->
                                            <input type="radio" v-model="state_name" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                                            <span>{{item}}</span>
                                        </div>
                                    </div>
                                </vs-row>
                            </vs-row>
                        </div>
                    </vx-card>
                </div>
                <div style="display: flex; justify-content: flex-end" class="pt-4" :key="isAdd">
                    <vs-button v-if="isAdd" @click="actionCreate" :disabled="!validateForm && submited" icon="person_add" color="success" style="padding: 8px; margin-right: 5px;height: 37px">登録</vs-button>
                    <vs-button v-else @click="actionUpdate(false)" :disabled="!validateForm" icon="assignment" color="success" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
                    <vs-button v-if="!isAdd" @click="actionUpdate(true)" :disabled="(!validateForm) || (this.state_flg != VALID_WITHOUT_PWD && state_name == NAME_INVALID)" icon="mail" color="warning" style="padding: 8px; margin-right: 5px;height: 37px">パスワード設定依頼</vs-button>
                    <vs-button v-if="!isAdd" @click="activeDelete = true" icon="delete" color="danger" style="padding: 8px; margin-right: 5px;height: 37px">削除</vs-button>
                    <vs-button @click="activeInnerPopup = false" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
                </div>
            </div>
        </vs-popup>

        <!-- AgGrid Table -->
        <ag-grid-vue
                id="myGrid"
                ref="agGridTable"
                :components="components"
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table database"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="usersData"
                colResizeDefault="shift"
                :animateRows="true"
                :pagination="false"
                :domLayout="domLayout"
                :paginationPageSize="paginationPageSize"
                :suppressPaginationPanel="true"
                :enableRtl="$vs.rtl"
                :overlayNoRowsTemplate="noRowsTemplate"
                :detailRowAutoHeight="true"
                @rowClicked="editAdmin"
        >
        </ag-grid-vue>
    </div>

</template>

<script>
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import {AgGridVue} from 'ag-grid-vue'
    import {mapActions} from 'vuex'
    import UserStateFlag from "../../../enums/UserStateFlag";

    export default {
        components: {
            AgGridVue,
        },
        props: {
          companyAdmin: { type: Array, default: [] },
          company: { type: Object, default: null },
          isShow: { type: Boolean, default: true },
        },
        data () {
            return {
                VALID_WITHOUT_PWD: UserStateFlag.VALID_WITHOUT_PWD,
                NAME_INVALID: UserStateFlag.NAME_INVALID,
                activeInnerPopup:     false,
                activeDelete:    false,
                submited:        false,
                title:           '',
                login_id:        null,
                phone_number:    null,
                password:        null,
                email:           null,
                given_name:      null,
                family_name:     null,
                state_name:      UserStateFlag.NAME_INVALID,
                mst_mail_server: [],
                state_flg:       UserStateFlag.VALID_WITHOUT_PWD,

                // Filter Options
                stateFlgOptions: [
                  UserStateFlag.NAME_VALID,UserStateFlag.NAME_INVALID
                ],

                paginationOptions: [
                    10, 20, 30, 50
                ],

                //SortServer
                orderBy: 'id',
                orderDir: 'asc',

                //Pagination
                paginationPageSize: 10,
                pageNumber: 1,
                startRow: 0,
                endRow: 0,

                // AgGrid
                noRowsTemplate: "<span>データがありません</span>",
                domLayout: 'autoHeight',
                gridApi: null,
                gridOptions: {},
                defaultColDef: {
                    sortable: false,
                    resizable: true,
                    suppressMenu: true,
                    sortingOrder: ['asc', 'desc'],
                },
                columnDefs: [
                    {
                        headerName: 'ログインID',
                        field: 'login_id',
                        width: 175,
                        filter: true,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: 'メールアドレス',
                        field: 'email',
                        width: 250,
                        filter: true,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '氏名',
                        field: 'name',
                        width: 200,
                        filter: true,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: '状態',
                        field: 'state_name',
                        filter: true,
                        width: 80,
                        unSortIcon: true,
                        suppressMovable: true,
                    }
                ],

                // Cell Renderer Components
                components: {},
                isAdd: false,
                admin: null,
                initialAdmin: {
                    mst_company_id: 0
                },
                adminList: [],
                usersData: [],
            }
        },
        computed: {
            validateForm(){
                return !this.errors.any()
            },
        },
        methods: {
            ...mapActions({
                showAdmin: 'company/showAdmin',
                createAdmin: 'company/createAdmin',
                fetchCompany: 'company/fetchCompany',
                fetchAdmin: 'company/fetchAdmin',
                updateAdmin: 'company/updateAdmin',
                deleteCompanyAdmin: 'company/deleteAdmin',
            }),
            setUpCreate(){
              this.isAdd = true
                // clear all fields before create
              this.state_name       = UserStateFlag.NAME_INVALID,
              this.login_id         = null,
              this.password         = null,
              this.phone_number     = null,
              this.email            = null,
              this.given_name       = null,
              this.family_name      = null,
              this.mst_mail_server  = null,
              this.state_flg        = 0,
              this.submited         = false,
              this.mst_mail_server  = []
              this.title            = '管理者情報登録'
              this.activeInnerPopup      = true
            },
            setUpUserData() {
                this.usersData = this.companyAdmin.slice(0).map(admin => ({...admin, name: admin.family_name + ' ' + admin.given_name, state_name: UserStateFlag.getText(admin.state_flg)}))
            },
            async refreshAdminList() {
              const admins = await this.fetchAdmin(this.company.id)
              this.adminList = admins || []
            },
            async actionCreate(){
                if(!this.validateForm){
                    this.submited = true; // first: no show error => after submited: show error
                }
                else{
                    let user = {
                        login_id:     this.login_id,
                        phone_number: this.phone_number,
                        email:        this.email,
                        given_name:   this.given_name,
                        family_name:  this.family_name,
                        mail_svr:     this.mst_mail_server
                    }
                    const res = await this.createAdmin({companyId: this.company.id, payload: user})
                    if (!res) return
                    this.activeInnerPopup = false
                    await this.refreshAdminList()
                }
            },
            async actionUpdate(sendPwdMail){
                if(this.state_flg != UserStateFlag.VALID_WITHOUT_PWD){
                    if(this.state_name == UserStateFlag.NAME_VALID) this.state_flg = UserStateFlag.VALID
                    else this.state_flg = UserStateFlag.INVALID
                }
                const payload = {
                  id:             this.admin.id,
                  login_id:       this.login_id,
                  phone_number:   this.phone_number,
                  email:          this.email,
                  given_name:     this.given_name,
                  family_name:    this.family_name,
                  mail_svr:       this.mst_mail_server,
                  state_flg:      this.state_flg,
                  sendPwdMail
                }
                const res = await this.updateAdmin({ companyId: this.company.id, userId: this.admin.id, payload})
                if (!res) return
                this.activeInnerPopup = false
                await this.refreshAdminList()
            },
            async confirmDelete(){
                if (!this.admin) return
                await this.deleteCompanyAdmin({ companyId: this.company.id, userId: this.admin.id});
                this.activeDelete = false
                this.activeInnerPopup = false
                this.admin = null
                await this.refreshAdminList()
            },
            async editAdmin(rowData) {
                    await this.showAdmin({ companyId: rowData.data.company.id, userId: rowData.data.id}).then(admin => {
                    this.admin = admin
                    this.login_id = admin.login_id
                    this.phone_number = admin.phone_number
                    this.email = admin.email
                    this.given_name = admin.given_name
                    this.state_flg = admin.state_flg
                    this.state_name = UserStateFlag.getText(this.state_flg)
                    this.family_name = admin.family_name
                    this.mst_mail_server = admin.mst_mail_server
                    this.activeInnerPopup = true
                    this.isAdd = false
                })
            },
            deleteAdmin(id) {
                this.activeDelete = true
            },
        },
        watch: {
            companyAdmin: {
                handler: function() {
                    this.setUpUserData();
                },
                deep: true
            },
            adminList: {
                handler: function() {
                    this.usersData = this.adminList.slice(0).map(admin => ({...admin, name: admin.family_name + ' ' + admin.given_name, state_name: UserStateFlag.getText(admin.state_flg)}))
                },
                deep: true
            },
        },
        mounted () {
            this.gridApi = this.gridOptions.api
            if (this.$vs.rtl) {
                const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
                header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
            }
        },
        async created () {
            this.admin = this.initialAdmin
        },
        destroyed(){
            // hiden popup while edit/update => click back/next on broswer (use activeInnerPopup = false not working)
            document.getElementById('dialogDelete').style.display = 'none'
            document.getElementById('dialogAdminUpdate').style.display = 'none'
        }
    }

</script>

<style lang="scss">
    @import "@/assets/scss/vuexy/components/view/company-setting.scss"
</style>
